import React from 'react';

import PropTypes from 'prop-types';

import { EventListGroupItem } from 'components/EventsCard/EventListGroupItem';

import './EventListGroup.scss';

export const EventListGroup = ({ events }) => (
  <div className="event-list-group">
    {events.map((event) => (
      <EventListGroupItem key={event.id} event={event} />
    ))}
  </div>
);

EventListGroup.propTypes = {
  events: PropTypes.array.isRequired,
};
